import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** https://jira.vk.team/browse/B2BCLOUD-5066 Единый поиск в новом веб-супераппе */
export const UNIFIED_SEARCH_IN_SUPERAPP_ENABLED = isFeature('unified-search-in-superapp');
